import PropTypes from 'prop-types';
import { useCallback } from 'react';
// @mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// utils
import { fDateTime } from 'src/utils/format-time';

// ----------------------------------------------------------------------

function formatType(type) {
  switch (type) {
    case "improper_unload":
      return "Descarga Indevida";
    case "manual_operation":
      return "Manual Operation";
    case "batch_material_deviation":
      return "Material Deviation";
    case "travel_without_unload":
      return "Travel Without Unload";
    case "parking_outside_fence":
      return "Outside Geofence";
    default:
      return type;
  }
}

export default function NotificationItem({ notification }) {
  const isResolved = Boolean(notification.resolved_at);

  const router = useRouter();
  const handleClick = useCallback(
    () => {
      router.openInNewTab(paths.dashboard.notifications.root);
    },
    [router]
  );

  return (
    <ListItemButton
      sx={{
        p: 2,
        alignItems: "flex-start",
        borderBottom: (theme) => `dashed 1px ${theme.palette.divider}`,
        opacity: isResolved ? 0.6 : 1,
      }}
      onClick={() => handleClick()}
    >
      <Stack sx={{ flexGrow: 1 }}>
        <Typography variant="subtitle2">
          {formatType(notification.type)}
        </Typography>

        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {notification.description}
        </Typography>

        <Typography variant="caption" sx={{ color: "text.disabled", mt: 0.5 }}>
          {fDateTime(notification.timestamp)}
        </Typography>

        {isResolved && (
          <Typography variant="caption" color="success.main">
            Resolvido
          </Typography>
        )}
      </Stack>
    </ListItemButton>
  );
}

NotificationItem.propTypes = {
  notification: PropTypes.object,
};
